import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { useLanguage } from '../../Services/LanguageContext';

interface IProps {
    dialogOpen: boolean;
    handleDialogConfirm: (x: any) => void;
    handleDialogAbort: (x: any) => void;
}

const WarningIcon = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ color: 'var(--danger)' }}
    >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
);

const DeleteConfirmation = (props: IProps) => {
    const { t } = useLanguage();
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={props.handleDialogAbort}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            PaperProps={{
                sx: {
                    background: 'var(--bg-secondary)',
                    borderRadius: '16px',
                    border: '1px solid var(--border-color)',
                    boxShadow: '0 0 40px rgba(239, 68, 68, 0.2)',
                    padding: '16px',
                    minWidth: '360px',
                },
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    },
                },
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ marginBottom: '16px' }}>
                    <WarningIcon />
                </div>
                <DialogTitle
                    sx={{
                        color: 'var(--text-primary)',
                        fontWeight: 700,
                        fontSize: '20px',
                        padding: '0 0 8px 0',
                    }}
                >
                    {t('delete')}?
                </DialogTitle>
                <DialogContent sx={{ padding: '0 0 24px 0' }}>
                    <DialogContentText
                        sx={{
                            color: 'var(--text-secondary)',
                            textAlign: 'center',
                            fontSize: '15px',
                        }}
                    >
                        {t('deleteConfirmation')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: 0, gap: '12px', width: '100%' }}>
                    <Button
                        onClick={props.handleDialogAbort}
                        sx={{
                            flex: 1,
                            padding: '12px 24px',
                            borderRadius: '10px',
                            background: 'var(--bg-tertiary)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)',
                            fontWeight: 600,
                            textTransform: 'none',
                            '&:hover': {
                                background: 'var(--bg-secondary)',
                                borderColor: 'var(--accent-cyan)',
                            },
                        }}
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        onClick={props.handleDialogConfirm}
                        sx={{
                            flex: 1,
                            padding: '12px 24px',
                            borderRadius: '10px',
                            background: 'linear-gradient(135deg, var(--danger), #dc2626)',
                            border: 'none',
                            color: 'white',
                            fontWeight: 600,
                            textTransform: 'none',
                            boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                                boxShadow: '0 6px 20px rgba(239, 68, 68, 0.4)',
                            },
                        }}
                    >
                        {t('confirm')}
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
};

export default DeleteConfirmation;
